import React from 'react';
import './count.css'

function C2wCourseCount( { obj } ) {
  return (
    <div className='C2wCourseCount'>
        <span>{`${obj?.count}`}</span>
        {`${obj?.heading}`}
    </div>
  )
}

export default C2wCourseCount
